/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import get from 'lodash.get';
import classNames from 'classnames';

import ErrorMetadata from 'components/PageMetadata/ErrorMetadata';
import ErrorMessage from 'components/ErrorMessage';
import { HeaderAndFooter } from 'components/services/HeaderAndFooter';
import IconfontStyleTag from 'components/IconfontStyleTag';
import { navbar, NAVBAR_THEME } from 'lib/navbar';
import getThemesCssPath from 'lib/getThemesCssPath';
import { layout as servicesLayoutPropType } from 'lib/CustomPropTypes/services';

import globalContainerStyles from './globalContainerStyles.module.scss';

const PAGE_TYPES = {
  404: 'NotFound',
  500: 'InternalServerError',
};

const navbarConfig = {
  theme: ({ vertical }) => {
    switch (vertical) {
      case 'today':
        return NAVBAR_THEME.TRANSPARENT;
      case 'news':
      case 'msnbc':
        return NAVBAR_THEME.VERTICAL;
      default:
        return NAVBAR_THEME.LIGHT;
    }
  },
};
function ErrorPage({
  statusCode,
  vertical,
  layout,
}) {
  const themesCssPath = getThemesCssPath(vertical);
  const isLayoutPresent = Boolean(Object.keys(layout).length);

  const Error = () => (
    <>
      <Head>
        {themesCssPath && (
          <link href={themesCssPath} rel="stylesheet" key={themesCssPath} />
        )}
        <IconfontStyleTag />
      </Head>

      <div>
        <ErrorMetadata
          pageType={PAGE_TYPES[statusCode] || PAGE_TYPES[500]}
        />
        <ErrorMessage code={statusCode} vertical={vertical} />
      </div>
    </>
  );

  const renderErrorPage = (withHeaderFooter, Component) => {
    if (withHeaderFooter) {
      return (
        <HeaderAndFooter layout={layout} vertical={vertical}>
          <Component />
        </HeaderAndFooter>
      );
    }

    return (
      <Component />
    );
  };

  return (
    <div className={classNames(globalContainerStyles.container)}>
      {renderErrorPage(isLayoutPresent, Error)}
    </div>
  );
}

ErrorPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  vertical: PropTypes.string,
  layout: servicesLayoutPropType.isRequired,
};

ErrorPage.defaultProps = {
  vertical: '',
};

ErrorPage.getInitialProps = async ({ res, err }) => {
  const resStatusCode = res && res.statusCode;
  const errStatusCode = err && err.statusCode;
  const getComponent = get(res, 'locals.services.layout.getComponent', () => {});
  const vertical = get(res, 'locals.vertical', 'news');
  const layout = {};
  const [header, footer] = await Promise.all([getComponent(vertical, 'header'), getComponent(vertical, 'footer')]);
  layout.header = header;
  layout.footer = footer;

  return {
    statusCode: resStatusCode || errStatusCode || 500,
    layout,
    vertical,
  };
};

export default navbar(navbarConfig)(ErrorPage);
